import IconButton from '@anm/components/buttons/IconButton';
import styled from 'styled-components';

export const MenuDropdownIconButton = styled(IconButton)`
  color: var(--gray_500);
  font-weight: 700;
  background-color: transparent;
  width: 100%;
  justify-content: flex-start;

  &:hover,
  &:focus {
    background-color: transparent;
  }
`;

export const DropdownContentItem = styled.a``;

export const DropdownContentWrapper = styled.ul`
  ${DropdownContentItem} {
    color: var(--gray_500);
    font-weight: bold;
    &:hover {
      background-color: var(--white);
      color: var(--gray_900);
    }
  }
`;
